/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class GebaudeSrukturEntry extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
        console.log('calcwidth')

        Utils.normalizeAddonWidths('#basedataentry')



    }

    render (){
        const {baseDataStore} = this.props;
        var entry = baseDataStore.strukturAuswahl
        var z = 200;
        var styles = {zIndex : z};
        return (<div id="basedataentry" className="well">
            <h4>Gebäudestruktur</h4>
            <hr/>

            <div key={entry.key} className="form-group zup" style={styles}>
                            <div className="input-group" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                            <div className="input-group-btn ">
                                <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                            </div>
                            </div>
                        </div>



            <div className="form-group zup" >
                <img src={`${process.env.PUBLIC_URL}/images/${entry.value.img}`} className="img-responsive"/>
            </div>
        </div>);
    }

}

GebaudeSrukturEntry.propTypes = {
    baseDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/GebaudeSrukturEntry.js